export var VERSION = "1.12.0";